import Repository from '@/repositories/repository'

const MetaTrader5Repository = {
  async getMetaTrader5Data(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('metatrader-5', 'page', params)
  }
}

export default MetaTrader5Repository
